require([
    "common/formUtils",
    "common/spinner",
    "common/slickSlider",
    "common/productSlides"
],
function (formUtils, spinner, slickSlider, productSlides) {

    const COMPONENTS_SELECTOR = ".product-components";
    const BUTTON_SELECTOR = COMPONENTS_SELECTOR + " .view-product-component";
    const IMAGE_SELECTOR = COMPONENTS_SELECTOR + " img";

    const MODAL_SELECTOR = "#product-components-modal";
    const MODAL_TITLE_SELECTOR = MODAL_SELECTOR + " .product-components-modal-title";
    const MODAL_BODY_SELECTOR = MODAL_SELECTOR + " .product-components-modal-body";
    const MODAL_SLIDER_SELECTOR = MODAL_BODY_SELECTOR + " .product-slides";
    const SPINNER_SELECTOR = MODAL_SELECTOR + " .spinner-wrapper";

    function init() {
        $(BUTTON_SELECTOR).on("click", viewButtonClicked);
        $(IMAGE_SELECTOR).on("click", viewButtonClicked);
        $(MODAL_SELECTOR).on("hidden.bs.modal", productSlides.pauseAllVideos);
    }

    function getComponentId(element) {
        let componentId = $(element).closest(".product-component").data("componentId");
        return componentId;
    }

    function getComponentTitle(element) {
        let componentTitle = $(element).closest(".product-component").find(".product-component-title").html();
        return componentTitle;
    }

    function viewButtonClicked(event) {
        let componentId = getComponentId(event.target);
        let componentTitle = getComponentTitle(event.target);
        showModal(componentId, componentTitle);
    }

    function showModal(componentId, componentTitle) {
        $(MODAL_TITLE_SELECTOR).empty().html(componentTitle);
        slickSlider.destroy(MODAL_SLIDER_SELECTOR)
        $(MODAL_BODY_SELECTOR).empty();
        spinner.show(SPINNER_SELECTOR);
        $(MODAL_SELECTOR).modal("show");
        fetchDataFromBackEnd(componentId);
    }

    function fetchDataFromBackEnd(componentId) {
        let postData = { SlideGroupId: componentId, SlidesName: "components" };
        formUtils.useToken(postData);
        $.ajax({
            type: "POST",
            url: "/customapi/Product/ProductSlides",
            dataType: "text",
            data: postData,
            success: function (data) {
                // fill the fetched HTML into DOM
                $(MODAL_BODY_SELECTOR).html(data);
                // initializing the slider has to be done with a slight delay, because slick cannot act immediately on the freshly generated DOM
                // (the first slide comes out mangled if we try to initialize the slider immediately)
                setTimeout(function () {
                    slickSlider.init(MODAL_SLIDER_SELECTOR);
                    $(MODAL_SLIDER_SELECTOR).on('afterChange', productSlides.pauseAllVideos);
                    spinner.hide(SPINNER_SELECTOR);
                    productSlides.init(MODAL_SLIDER_SELECTOR);
                }, 500);
            },
            error: function (jq, status, errorThrown) {
                spinner.hide(SPINNER_SELECTOR);
                $(MODAL_BODY_SELECTOR).text("We're very sorry, but there were problems with fetching the data. Please try again later or call customer service for help.");
                console.log("ERROR in fetching feature data. FeatureId= " + componentId + " Status=" + status + " " + jq.status + " Message=" + errorThrown + " " + jq.responseText);
            },
            complete: function () {
            }
        });
    }

    init();

});

define("ProductComponents/productComponents", function(){});

